// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2bo-1","left":"InfoRow_left__3AOEn"};